import Icon from '../components/Icon.vue'

Icon.register({
  quran: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 358.4V25.6C448 9.6 438.4 0 422.4 0H96C41.6 0 0 41.6 0 96V416C0 470.4 41.6 512 96 512H422.4C435.2 512 448 502.4 448 486.4V470.4C448 464 444.8 457.6 438.4 451.2 435.2 435.2 435.2 390.4 438.4 377.6 444.8 374.4 448 368 448 358.4zM301.1 145.8C301.7 144.6 302.8 144 304 144S306.3 144.6 306.9 145.8L318.1 168.5 343.1 172.1C345.8 172.5 346.8 175.8 344.9 177.7L326.8 195.3 331.1 220.2C331.5 222.3 329.8 224 327.9 224 327.4 224 326.9 223.9 326.4 223.6L304 211.9 281.6 223.6C281.1 223.9 280.6 224 280.1 224 278.2 224 276.6 222.3 276.9 220.2L281.2 195.3 263.1 177.7C261.2 175.8 262.2 172.5 264.9 172.1L289.9 168.5 301.1 145.8zM243.2 76.8C256.9 76.8 270.4 79.3 283.6 84.2A6.8-6.8 0 1 0 281.2 97.3C280.5 97.3 278.1 97.1 277.1 97.1 224.8 97.1 182.2 139.7 182.2 192 182.2 244.3 224.8 286.9 277.1 286.9 278.1 286.9 280.5 286.6 281.2 286.6 285.1 286.6 288 289.8 288 293.4 288 296.4 286.1 298.9 283.4 299.8 270.3 304.7 256.8 307.2 243.2 307.2 179.7 307.2 128 255.5 128 192 128 128.5 179.7 76.8 243.2 76.8zM380.8 448H96C76.8 448 64 435.2 64 416S80 384 96 384H380.8V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/quran.js
// module id = ZhA6
// module chunks = 144